import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import i18n from '@/lang/i18n';
import { computed, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchAndSortWindow',
  props: {
    width: { default: 100 },
    windowKey: { default: '' },
    sortKey: { default: '' },
    sortType: { default: '' },
    items: {},
    modelValue: {},
    candidateLabel: {},
    isSortable: { type: Boolean, default: true }
  },
  emits: ['update:modelValue', 'changeSortType', 'close', 'setSelect', 'search', 'setIsAllSelected'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

const sortItemColor = computed(() => (type: string) => {
  return props.sortKey == props.windowKey && props.sortType == type ? '#15829C' : '';
})

const isAllSelected = computed(() => {
  return Object.values(modelValue.value).every((value) => value === true);
});

function changeSortType(type: string) {
  emits('changeSortType', type)
}

function handleSearch() {
  emits('search');
  emits('setIsAllSelected', { windowKey: props.windowKey, isAllSelected: isAllSelected.value });
}

onMounted(() => {
  emits('setIsAllSelected', { windowKey: props.windowKey, isAllSelected: isAllSelected.value });
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_action = _resolveComponent("v-card-action")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    style: _normalizeStyle(`width: ${props.width}px;`)
  }, {
    default: _withCtx(() => [
      (props.isSortable)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "sort-item justify-content-center mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_action, { style: {"width":"85%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "w-100",
                    style: _normalizeStyle(`color: ${sortItemColor.value('ASC')}`),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSortType('ASC')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.list.sort.asc')), 1)
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (props.isSortable)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "sort-item justify-content-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_action, { style: {"width":"85%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "w-100",
                    style: _normalizeStyle(`color: ${sortItemColor.value('DESC')}`),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSortType('DESC')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.list.sort.desc')), 1)
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, {
        class: "select-action mt-4 mx-auto d-flex justify-content-between",
        style: {"width":"80%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_action, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                style: {"height":"30px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('setSelect', true, props.windowKey)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.allSelect')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_action, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "w-100",
                style: {"height":"30px"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('setSelect', false, props.windowKey)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.clear')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, {
            class: "mx-auto",
            style: {"width":"98%"}
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_component_v_row, { class: "w-100 d-flex justify-content-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, {
            class: "selectable-items mx-auto pt-0 mb-2",
            style: {"width":"98%","max-height":"200px","height":"100%"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.items || []), (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item?.id
                }, [
                  item
                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                        key: 0,
                        label: item[props.candidateLabel],
                        modelValue: modelValue.value[item.id],
                        "onUpdate:modelValue": ($event: any) => ((modelValue.value[item.id]) = $event),
                        dencity: "compact"
                      }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        class: "my-2 d-flex justify-content-end",
        style: {"width":"98%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_action, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "mr-2",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('close', false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.close')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_action, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "exec-btn",
                onClick: handleSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["style"]))
}
}

})